
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router';
import * as d3 from 'd3';
import { simplePlaceName } from '../../utils/utils';
import styles from './ReducingYourRiskData.css';
import withStyles from '../../decorators/withStyles';


class ReducingYourRiskData extends Component {

  static propTypes = {
    placeType: PropTypes.string.isRequired,
    placeID: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {data: {state: [], national: []}}
  }

  async loadData() {
    var self = this;
    const { placeType, placeID }  = this.props;
    const url = '/api/resources/' + placeType + '/' + placeID;
    const data = await d3.json(url);
    self.setState({
      data: {
        state: data.filter((obj) => obj.state !== "National"),
        national: data.filter((obj) => obj.state === "National")
      }
    });
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(props) {
    if (props.placeID !== this.props.placeID || props.placeType !== this.props.placeType) {
      this.loadData();
    }
  }

  render() {
    return (
      <div className="ReducingYourRiskData">
        <div>{React.Children.map(this.props.children,
          child => React.cloneElement(child, {
            data: this.state.data,
            ...this.props
          }))}
        </div>
      </div>
    );
  };
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(ReducingYourRiskData);
